import {component} from '../form/Constant'
import {nokRelationList} from '../patient/PatientConstants'

export const nextOfKin = {
    fullName: 'fullName',
    email: 'email',
    description: 'description',
    relationship: 'relationship',
    addressLine1: 'addressLine1',
    addressLine2: 'addressLine2',
    addressLine3: 'addressLine3',
    addressLine4: 'addressLine4',
    address: 'address',
}

export const nextOfKinList = [
    {
        key: 'information',
        description: ' Fill in the relevant information details.',
        required: true,
        children: [
            {
                key: nextOfKin.fullName,
                component: component.inputText,
                placeholder: 'Field is required',
            },
            {
                key: nextOfKin.email,
                component: component.inputText,
                keyFilter: true,
                placeholder: 'Input email',
            },
            {
                key: nextOfKin.description,
                component: component.inputText,
                placeholder: 'Input description',
            },
            {
                key: nextOfKin.relationship,
                component: component.dropdown,
                options: nokRelationList,
                defaultValue: nokRelationList[0].value,
                placeholder: 'Select a relationship',
            },
        ],
    },
    {
        key: 'contactInformation',
        description: ' Fill in the relevant contact details.',
        required: true,
        children: [
            {
                key: nextOfKin.address,
                hideHeader: true,
                component: component.address,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
]
